var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("商品管理")]),
              _c("el-breadcrumb-item", [_vm._v("规格管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v(" 新增 ")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: { slot: "content", data: _vm.tableData, border: "" },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", width: "60", label: "序号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              (_vm.pager.pageIndex > 1
                                ? (_vm.pager.pageIndex - 1) * _vm.pager.pageSize
                                : 0) +
                                scope.$index +
                                1
                            ),
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "title", align: "center", label: "规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "weight", align: "center", label: "重量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.weight) + "g")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "pieceUnit",
                  align: "center",
                  label: "计价方式",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pieceUnit === 0
                          ? _c("span", [_vm._v("计重")])
                          : _vm._e(),
                        scope.row.pieceUnit === 1
                          ? _c("span", [_vm._v("计件")])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editItem(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该条数据？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.deleteItem(scope.row.id)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    rules: _vm.checkItemParams,
                    model: _vm.itemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title", label: "规格：" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "请输入规格" },
                        model: {
                          value: _vm.itemParams.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.itemParams, "title", $$v)
                          },
                          expression: "itemParams.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "weight", label: "重量：" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { size: "small", placeholder: "请输入重量" },
                          model: {
                            value: _vm.itemParams.weight,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "weight", $$v)
                            },
                            expression: "itemParams.weight",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("g")])],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "pieceUnit", label: "计价方式：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "small",
                            placeholder: "请选择计价方式",
                          },
                          model: {
                            value: _vm.itemParams.pieceUnit,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "pieceUnit", $$v)
                            },
                            expression: "itemParams.pieceUnit",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 0, label: "计重" },
                          }),
                          _c("el-option", {
                            attrs: { value: 1, label: "计件" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.isDisabled,
                            size: "small",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveSpecification("dialogForm")
                            },
                          },
                        },
                        [_vm._v(" 保 存 ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v(" 取 消 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }